import React, { useEffect, useReducer } from "react";
import { useInView } from "react-intersection-observer";
import { API } from "../../../request/api";
import produce from "immer";
import { Note } from "../../../helbest";

function reducer(state, action) {
  switch (action.type) {
    case "LOADING": {
      return produce(state, (draft) => {
        draft.isLoading = true;
      });
    }
    case "SUCCESS": {
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.data = [...state.data, ...action.data];
        draft.page = state.page + 1;
        draft.hasMore = action.hasMore;
      });
    }
    case "REFETCH": {
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.data = action.data;
        draft.page = 2;
        draft.hasMore = action.hasMore;
      });
    }
    case "FINALLY": {
      return produce(state, (draft) => {
        draft.isLoading = false;
      });
    }
    case "SEARCH": {
      return produce(state, (draft) => {
        draft.hasMore = true;
        draft.page = 1;
        draft.data = [];
        draft.errorStatus = null;
      });
    }
    case "ERROR": {
      return produce(state, (draft) => {
        draft.hasMore = true;
        draft.page = 1;
        draft.data = [];
        draft.errorStatus = 403;
      });
    }
  }
}

export default function useEmployees(q) {
  const [state, dispatch] = useReducer(reducer, {
    data: [],
    isLoading: false,
    page: 1,
    hasMore: true,
    errorStatus: null,
  });

  const { ref: loadMoreRef, inView } = useInView({
    threshold: 0.1,
  });

  const fetchNextPage = async () => {
    if (state.isLoading || !state.hasMore) return;
    fetchData(false);
  };

  const fetchData = async (refetch) => {
    dispatch({
      type: "LOADING",
    });
    API.get
      .getEmployees(refetch ? 1 : state.page, q)
      .then((response) => {
        if (response.code === 200) {
          let hasMore;
          if (response.pagination.next) {
            hasMore = true;
          } else {
            hasMore = false;
          }
          dispatch({
            type: refetch ? "REFETCH" : "SUCCESS",
            data: response.data,
            hasMore,
          });
        } else if (response.code === 403) {
          dispatch({
            type: "ERROR",
          });
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        dispatch({
          type: "FINALLY",
        });
      });
  };

  useEffect(() => {
    dispatch({
      type: "SEARCH",
    });
    fetchData(true);
  }, [q]);

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [inView]);

  return {
    data: state.data,
    errorStatus: state.errorStatus,
    loadMoreRef,
    isLoading: state.isLoading,
    refetch: () => fetchData(true),
  };
}
